import AxiosInstance from "./api";

export const JournalVoucher4Service = {
  create: (payload) => AxiosInstance.post("/private/journal-voucher-4", payload),
  update: (id, payload) => AxiosInstance.put(`/private/journal-voucher-4/${id}`, payload),
  delete: (id) => AxiosInstance.delete(`/private/journal-voucher-4/${id}`),
  findAll: (params) => AxiosInstance.get("/private/journal-voucher-4", { params }),
  findById: (id) => AxiosInstance.get(`/private/journal-voucher-4/${id}`),
  preview: (params) => AxiosInstance.get("/private/journal-voucher-4/sync/preview", { params }),
  sync: (params) => AxiosInstance.post("/private/journal-voucher-4/sync", null, { params }),
  getAccounts: (params) => AxiosInstance.get("/private/journal-voucher-4/accounts", { params }),
};